import type { TrackingMetadata } from "../videoMeeting.types";

declare global {
  interface Window {
    posthog?: {
      get_session_id?: () => string;
      config?: { session_id?: string };
      session_id?: string;
    };
  }
}

const getPostHogSessionId = (): string => {
  try {
    if (typeof window !== "undefined" && window.posthog) {
      if (typeof window.posthog.get_session_id === "function") {
        const sessionId = window.posthog.get_session_id();
        if (sessionId) return sessionId;
      }
      if (window.posthog.config?.session_id) {
        return window.posthog.config.session_id;
      }
      if (window.posthog.session_id) {
        return window.posthog.session_id;
      }
    }
  } catch {
    // PostHog unavailable
  }
  return `fallback_session_${Math.floor(Date.now() / 1000)}`;
};

export const getTrackingMetadata = (
  user: { id: number } | null
): TrackingMetadata => ({
  user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
  user_id: user?.id ?? 0,
  posthog_session_id: getPostHogSessionId(),
});
